import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { API_BASE_URL } from "../../config/apiConfig";

const SelectQuizFree = () => {
    const navigate = useNavigate();
    const [selectedExam, setSelectedExam] = useState({
        subject: "",
        mode: "",
        testId: "",
    });
    const [selectedFilters, setSelectedFilters] = useState({
        year: "",
        subject: "",
        mode: "",
        answerType: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [userResults, setUserResults] = useState([]);

    useEffect(() => {
        const fetchUserResults = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/answer-free/user`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Failed to fetch user results.");
                }

                const resultData = await response.json();
                console.log(resultData.data);
                setUserResults(resultData.data);
            } catch (error) {
                console.error("Error fetching results:", error.message);
                setError("Failed to fetch user results.");
            }
        };

        fetchUserResults();
    }, []);

    const handleQuizSelection = (subject, mode, testId) => {
        const filteredResults = userResults.filter(
            (item) =>
                item.subject === subject && item.mode === mode && item.test_id === testId
        );

        if (filteredResults.length === 0) {
            setError("No results found for the selected criteria.");
            return;
        }

        navigate("/result", { state: { result: filteredResults } });
    };

    const goBack = () => {
        navigate("/free-dashboard");
    };

    const getUniqueExamData = () => {
        const uniqueExamDataMap = new Map();

        userResults.forEach((item) => {
            const uniqueKey = `${item.subject}_${item.mode}_${item.test_id}_${item.answerType}`;
            if (!uniqueExamDataMap.has(uniqueKey)) {
                uniqueExamDataMap.set(uniqueKey, {
                    subject: item.subject,
                    mode: item.mode,
                    answerType: item.answerType,
                    testId: item.test_id,
                    createdAt: item.createdAt,
                });
            }
        });

        return Array.from(uniqueExamDataMap.values());
    };

    const getFilterOptions = (key) => {
        const uniqueValues = new Set(
            userResults.map((item) =>
                key === "year"
                    ? new Date(item.createdAt).getFullYear()
                    : key === "subject"
                        ? item.subject
                        : key === "mode"
                            ? item.mode
                            : key === "answerType"
                                ? item.answerType
                                : null
            )
        );
        return Array.from(uniqueValues).filter(Boolean);
    };

    const filteredExamData = getUniqueExamData().filter((data) => {
        const year = new Date(data.createdAt).getFullYear();
        return (
            (!selectedFilters.year || year === parseInt(selectedFilters.year)) &&
            (!selectedFilters.subject || data.subject === selectedFilters.subject) &&
            (!selectedFilters.mode || data.mode === selectedFilters.mode) &&
            (!selectedFilters.answerType ||
                data.answerType === selectedFilters.answerType)
        );
    });

    

    return (
        <div className="flex flex-col min-h-screen bg-gray-100">
            <div className="flex items-center mt-6 ml-3">
                <button
                    onClick={goBack}
                    className="flex items-center gap-2 text-[#2148C0] hover:text-blue-600 font-medium transition"
                >
                    <FaArrowLeft className="text-xl" />
                    Back
                </button>
            </div>

            <main className="flex-grow flex flex-col items-center justify-center bg-gray-100 py-8">
                <h1 className="text-3xl text-center font-semibold text-[#2148C0] mb-6">
                    Check Your Quiz Result
                </h1>

                {error && <p className="text-red-500 mb-4">{error}</p>}

                {/* FILTERS */}
                <div className="w-full max-w-5xl mb-6 flex flex-col md:flex-row gap-4">
                    <select
                        className="w-full p-2 border rounded-lg"
                        value={selectedFilters.year}
                        onChange={(e) =>
                            setSelectedFilters((prev) => ({ ...prev, year: e.target.value }))
                        }
                    >
                        <option value="">All Years</option>
                        {getFilterOptions("year").map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>

                    <select
                        className="w-full p-2 border rounded-lg"
                        value={selectedFilters.subject}
                        onChange={(e) =>
                            setSelectedFilters((prev) => ({
                                ...prev,
                                subject: e.target.value,
                            }))
                        }
                    >
                        <option value="">All Subjects</option>
                        {getFilterOptions("subject").map((type) => (
                            <option key={type} value={type}>
                                {type}
                            </option>
                        ))}
                    </select>

                    <select
                        className="w-full p-2 border rounded-lg capitalize"
                        value={selectedFilters.mode}
                        onChange={(e) =>
                            setSelectedFilters((prev) => ({ ...prev, mode: e.target.value }))
                        }
                    >
                        <option value="">All Modes</option>
                        {getFilterOptions("mode").map((mode) => (
                            <option key={mode} value={mode} className="capitalize">
                                {mode}
                            </option>
                        ))}
                    </select>

                    <select
                        className="w-full p-2 border rounded-lg capitalize"
                        value={selectedFilters.answerType}
                        onChange={(e) =>
                            setSelectedFilters((prev) => ({
                                ...prev,
                                answerType: e.target.value,
                            }))
                        }
                    >
                        <option value="">All Answer Types</option>
                        {getFilterOptions("answerType").map((type) => (
                            <option key={type} value={type} className="capitalize">
                                {type}
                            </option>
                        ))}
                    </select>
                </div>

                {/* TABLE */}
                <div className="w-full max-w-5xl overflow-x-auto">
                    <table className="table-auto w-full border-collapse border border-gray-300 shadow-lg text-sm md:text-base">
                        <thead>
                            <tr className="bg-[#2148C0] text-white">
                                <th className="border border-gray-300 px-4 py-2">Date</th>
                                <th className="border border-gray-300 px-4 py-2">Subject</th>
                                <th className="border border-gray-300 px-4 py-2">Mode</th>
                                <th className="border border-gray-300 px-4 py-2">
                                    Answer Type
                                </th>
                                <th className="border border-gray-300 px-4 py-2">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredExamData.map((data, index) => (
                                <tr
                                    key={index}
                                    className={`hover:bg-blue-50 ${selectedExam.testId === data.testId ? "bg-blue-100" : ""
                                        }`}
                                >
                                    <td className="border border-gray-300 px-4 py-2 text-center">
                                        {new Date(data.createdAt).toLocaleDateString("en-US", {
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                        })}
                                    </td>
                                    <td className="border border-gray-300 px-4 py-2 text-center">
                                        {data.subject}
                                    </td>
                                    <td className="border border-gray-300 px-4 py-2 text-center capitalize">
                                        {data.mode}
                                    </td>
                                    <td className="border border-gray-300 px-4 py-2 text-center capitalize">
                                        {data.answerType}
                                    </td>
                                    <td className="border border-gray-300 px-4 py-2 text-center">
                                        <button
                                            className="px-3 py-1 md:px-4 md:py-2 bg-[#2148C0] text-white rounded-lg hover:bg-blue-600 transition text-xs md:text-sm"
                                            onClick={() =>
                                                handleQuizSelection(
                                                    data.subject,
                                                    data.mode,
                                                    data.testId
                                                )
                                            }
                                        >
                                            Check Result
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </main>

            <footer className="text-center text-gray-300 py-4 bg-black bg-opacity-40">
                <p>
                    &copy; {new Date().getFullYear()} TeeChaa CBT Application. All rights
                    reserved.
                </p>
            </footer>
        </div>
    );
};

export default SelectQuizFree;
